import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export interface TopMetricsQuery {
  dateFrom?: Date;
  dateTo?: Date;
  warehouse?: any[];
}

export const fetchTopMetrics = createAsyncThunk(
  "topMetrics/fetchTopMetrics",
  async (query: TopMetricsQuery = {}, { rejectWithValue }: any) => {
    try {
      const params = new URLSearchParams();

      // Add date filters
      if (query.dateFrom) {
        params.append("date_from", query.dateFrom.toISOString().split('T')[0]);
      }
      if (query.dateTo) {
        params.append("date_to", query.dateTo.toISOString().split('T')[0]);
      }

      // Add warehouse filters (exclude "all" option)
      if (query.warehouse && query.warehouse.length > 0) {
        const warehouseIds = query.warehouse
          .map((w: any) => w.warehouse_id)
          .filter((id: any) => id !== "all" && id !== "All Warehouses");

        if (warehouseIds.length > 0) {
          if (warehouseIds.length === 1) {
            params.append("warehouse_id", warehouseIds[0].toString());
          } else {
            params.append("warehouse_id", warehouseIds.join(','));
          }
        }
      }

      const url = `${api?.dashboad?.metrics}${params.toString() ? `?${params.toString()}` : ''}`;
      const response = await Axios.get(url);

      if (response.data?.data) {
        const data = response.data.data;
        // Format the data to match the component's expected structure
        return {
          totalSalesOrders: {
            value: data.total_orders || 0,
            growth: data.total_orders || 0,
            label: "Total Sales Orders",
          },
          totalQuotations: {
            value: data.total_quotations || 0,
            growth: data.quotations_growth || 0,
            label: "Total Quotations",
          },
          totalEnquiries: {
            value: data.total_enquiries || 0,
            growth: data.enquiries_growth || 0,
            label: "Total Enquiries",
          },
          totalDispatch: {
            value: data.total_dispatches || 0,
            growth: data.dispatch_growth || 0,
            label: "Total Dispatch (Completed)",
          },
        };
      }

      // Return default values if data is missing
      return {
        totalSalesOrders: {
          value: 0,
          growth: 0,
          label: "Total Sales Orders",
        },
        totalQuotations: {
          value: 0,
          growth: 0,
          label: "Total Quotations",
        },
        totalEnquiries: {
          value: 0,
          growth: 0,
          label: "Total Enquiries",
        },
        totalDispatch: {
          value: 0,
          growth: 0,
          label: "Total Dispatch (Completed)",
        },
      };
    } catch (err: any) {
      return rejectWithValue(err?.response?.data || "Network Error");
    }
  }
);

